// extracted by mini-css-extract-plugin
export default {"openingTimesTable":"openingTime__openingTimesTable___Dx4tF"};